import { Permission } from "../types/permission";
import HourglassGlobals from "./globals";

export const hasPermission = (perm: Permission) => HourglassGlobals.permissions.has(perm);